module.exports = __webpack_public_path__ + "static/img/erweima2_ysyc.428f570.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erweima2_ysyc.png
// module id = JNMo
// module chunks = 37